import * as React from "react";
const SvgVariant = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 12, y: 2, width: 14.1421, height: 14.1421, transform: "rotate(45 12 2)", fill: "currentColor" }));
export default SvgVariant;
